import React, { useState, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import { Link } from 'react-router-dom'
import moment from 'moment-jalaali'
// import {
//   Create as CreateIcon,
//   Delete as DeleteIcon,
// } from '@material-ui/icons'
import {
  Button,
  Dialog,
  IconButton,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core'
import DeleteIcon from 'src/icons/DeleteIcon'
import EditIcon from 'src/icons/EditIcon'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { getAllAgeCategories, selectorAgeCategories } from 'src/app/slices/notificationSlice'
import { getMuiTheme } from '../../utils/TableStyle'
import { getGroups, deleteGroup } from '../../app/slices/refereeGroupsSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

const useStyles = makeStyles(() => ({
  root: {
    '&.MuiPaper-root': {
      // borderRadius: '100px',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  deleteDialog: {
    '& .MuiDialog-paperWidthSm': {
      // width: '587px',
      width: '50%',
      height: '189px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#f5aca8, #eb5c55)',
    color: '#ffffff',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '17px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
  deleteModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      color: '#ffffff',
    },
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#e6332a',
    textAlign: 'center',
    border: '2px solid #e6332a',
    boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      color: '#ffffff',
    },
  },
}))

const RefereeGroups = () => {
  const groups = useSelector((state) => state.refereeGroups.list)
  const ages = useSelector(selectorAgeCategories)
  const loggedInUser = useSelector((state) => state.user.role.roleId)
  const classes = useStyles()

  const dispatch = useDispatch()
  const [groupToDelete, setGroupToDelete] = useState(null)
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    dispatch(getGroups({ type: loggedInUser === 10 ? 2 : 1 }))
    dispatch(getAllAgeCategories())
  }, [refresh])

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => {
          return (
            <p>
              {rowIndex + 1}
            </p>
          )
        },
      },
    },
    {
      name: 'name',
      label: 'نام گروه',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (
          <p
            style={{
              color: '#000',
              whiteSpace: 'nowrap',
              float: window.outerWidth < 960 ? 'left' : '',
            }}
          >
            {value}
          </p>
        ),
      },
    },
    {
      name: 'ageCategory',
      label: 'گروه سنی',
      options: {
        sort: false,
        filter: true,
        customBodyRender: (value) => {
          const name = ages?.find((age) => +age.ageCategoryId === +value?.ageCategoryId)?.name
          console.log(value?.ageCategoryId, 'fkjgnjkof')
          return (
            <p
              style={{
                color: '#000',
                whiteSpace: 'nowrap',
                float: window.outerWidth < 960 ? 'left' : '',
              }}
            >
              {name}

            </p>
          )
        },
        filterOptions: {
          fullWidth: true,
          names: ages.map((age) => age.name),
        },
      },
    },
    {
      name: 'scholarshipRequestCount',
      label: 'درخواست های فعال',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
        sort: false,
        filter: false,
      },
    },
    {
      // name: 'actions',
      name: 'id',
      label: 'مدیریت',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowData }) => {
          return (
            <>
              <Link
                // to={`./edit/${rowData[0]}/${rowData[2]}/${rowData[1]}`}
                to={`./edit/${value}`}
              >
                <IconButton>
                  <EditIcon className={classes.icons} />
                </IconButton>

              </Link>
              <IconButton onClick={() => {
                console.log(rowData)
                setGroupToDelete(value)
              }}
              >

                <DeleteIcon
                  className={classes.icons}
                />
              </IconButton>
            </>
          )
        },
      },
    },
  ]

  const handleClose = (shouldDelete) => {
    console.log('groupToDelete', groupToDelete)
    if (shouldDelete) {
      setRefresh(!refresh)
      dispatch(deleteGroup(
        groupToDelete, () => setRefresh(!refresh),
      ))
      setGroupToDelete(null)
    }
    // setGroupToDelete(null)
  }

  return (
    <>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          data={groups}
          columns={COLUMNS}
          options={{
            ...muiDefaultOptions,
            enableNestedDataAccess: '.',
            filterType: 'multiselect',
            rowHover: false,
            selectableRows: 'none',
          }}
        />
      </ThemeProvider>
      <Dialog
        className={classes.deleteDialog}
        open={groupToDelete}
        // onClose={() => handleClose(false)}
        onClose={() => setGroupToDelete(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">حذف گروه</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            آیا از حذف این گروه اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button onClick={() => setGroupToDelete(null)} className={classes.cancelModalBtn}>
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} className={classes.deleteModalBtn} autoFocus>
            بلی
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RefereeGroups
